var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.82051C5 3.26279 6.26279 2 7.82051 2H16.0256C17.5834 2 18.8462 3.26279 18.8462 4.82051V19.1795C18.8462 20.7372 17.5834 22 16.0256 22H7.82051C6.26279 22 5 20.7372 5 19.1795V4.82051ZM7.82051 3.53846C7.11246 3.53846 6.53846 4.11246 6.53846 4.82051V19.1795C6.53846 19.8875 7.11246 20.4615 7.82051 20.4615H16.0256C16.7337 20.4615 17.3077 19.8875 17.3077 19.1795V4.82051C17.3077 4.11246 16.7337 3.53846 16.0256 3.53846H7.82051ZM11.1538 18.1538C11.1538 17.729 11.4982 17.3846 11.9231 17.3846H11.9333C12.3582 17.3846 12.7026 17.729 12.7026 18.1538C12.7026 18.5787 12.3582 18.9231 11.9333 18.9231H11.9231C11.4982 18.9231 11.1538 18.5787 11.1538 18.1538Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMobile);
export default __webpack_public_path__ + "static/media/small-mobile.2262086a1a4d182a699b6925ef513b46.svg";
export { ForwardRef as ReactComponent };